package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class Playoffs(
    val alliances: List<Schedule.Alliance>,
    val matches: List<Schedule.Match>,
)
